export const amoswebLogs: TableModule = {
    name: "amoswebLogs",
    route: "spa.events.events.amoswebLogs",
    routeParams: [{
        param: "event",
        prop: "event_id"
    }],
    defaultOrder: {
        column: "amosweb_logs.created_at",
        direction: "desc"
    },
    columns: [
        {
            name: "created_at",
            sortBy: "amosweb_logs.created_at",
            mobile: true,
            sortable: true,
            width: "w-[100px]"
        },
        {
            name: "level",
            sortBy: "amosweb_logs.level",
            mobile: true,
            sortable: true,
            width: "w-[110px]"
        },
        {
            name: "status_code",
            mobile: true,
            sortable: true,
            width: "w-[100px]"
        },
        {
            name: "method",
            mobile: true,
            sortable: true,
            width: "sm:w-[100px]"
        },
        {
            name: "endpoint",
            truncate: false
        },
        {
            name: "message",
            truncate: false
        },
    ],
    filters: [
        {
            name: "level",
            column: "amosweb_logs.level",
            type: "select",
            options: () => ['error', 'warning', 'info'].map((level) => ({
                value: level,
                label: useNuxtApp().$i18n.t(`amoswebLogs.levels.${level}`)
            }))
        }
    ],
    quickFilters: [
        {
            name: "qf_onlyErrors",
            column: "amosweb_logs.level",
            value: "error",
            operator: "="
        }
    ],
    tools: []
}